import { createTransportLogger, MessageDirection, wrap } from "./shared";
const log = createTransportLogger("WebKit");
export const buildWebKitTransport = ()=>{
    return new WebKitTransport();
};
class WebKitTransport {
    postMessage(messages) {
        log.debug("Attempting to send messages", messages);
        let anyWindow = window;
        log.debug("Checking window.webkit availability", {
            hasWebkit: !!anyWindow.webkit,
            hasMessageHandlers: !!anyWindow.webkit?.messageHandlers,
            hasPaywallHandler: !!anyWindow.webkit?.messageHandlers?.paywallMessageHandler
        });
        const wrappedOutgoingMessage = wrap(messages, MessageDirection.FromPaywall);
        log.debug("Wrapped message for transport", wrappedOutgoingMessage);
        if (anyWindow.webkit && anyWindow.webkit.messageHandlers && anyWindow.webkit.messageHandlers.paywallMessageHandler) {
            log.info("Sending message via WebKit message handler");
            anyWindow.webkit.messageHandlers.paywallMessageHandler.postMessage(wrappedOutgoingMessage);
            return;
        }
        log.warn("Unable to send message - WebKit message handler not available");
    }
    _handlers = [];
    addListener(handler) {
        this._handlers.push(handler);
    }
    _listening = false;
    startListening() {
        this._listening = true;
    }
    accept(message) {
        if (this._listening) {
            this._handlers.forEach((handler)=>handler(message));
        }
    }
}
